orders-planner-dialog-create-schedule(class="{show: isShow}")
  .orders-planner-dialog-create-schedule.popper
    forms-schedules-create(tag-scope="forms_schedules_create" data-dialog="{true}")
    .popper__arrow(x-arrow)
  script(type="typescript").
    this.mixin('orders.planner.dialog.create-schedule');
